export default __webpack_public_path__ + "static/media/example-spreadsheet-route.231e7c52.xlsx";